import styled from '@emotion/styled';
import { icons } from '@assets/icons';
import { StyledProps } from '@components/atoms/Inputs/Select';

export const PickerIcon = styled.span`
  position: absolute;
  content: url(${icons.datepicker_range});
  width: 13px;
  height: 13px;
  cursor: pointer;
  margin-right: 16px;
  right: 0;
  top: 13px;
`;
export const DateRangeWrapper = styled.section`
  font: normal normal normal 12px/20px Noto Sans KR;
  height: 30px;
  width: 180px;
  margin-left: 20px;
  border-radius: 4px;
  input {
    text-align: left;
    border: none;
    letter-spacing: normal;
  }
  &.show-border {
    & input {
      border: 1px solid #00bf00 !important;
    }
    &:hover {
      & input {
        border: 1px solid #00bf00 !important;
      }
    }
  }

  &:hover {
    & input {
      border: 1px solid #777 !important;
      border: none;
      cursor: pointer;
    }
  }
  ${(props: StyledProps) => props.styles};

  &.log.show-border {
    &:hover {
      & input {
        border: unset !important;
      }
    }
  }
  &.log:hover {
    & input {
      border: unset;
      cursor: pointer !important;
    }
  }
`;
export const DateRangeInput = styled.input`
  height: 30px;
  width: 100%;
  display: inline-block;
  border: 1px solid #e0e0e0 !important;
  border-radius: 4px !important;
  font: normal normal normal 14px/20px Noto Sans KR;
  color: #cccccc;
  text-align: center;
  background-color: transparent;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  letter-spacing: 1px;
  padding-top: 0;
  padding-bottom: 0;
  outline: none;
  box-sizing: border-box;
  &:active,
  :focus {
    /* border: 1px solid #00bf00 !important; */
    border: none;
  }
`;
export const DateRangeSection = styled.div`
  z-index: 99;
  position: absolute;
  top: 0;
  right: -396px;
  display: flex;
  padding: 31px 34px;
  width: 388px;
  background-color: #fff;
  border: 1px solid #00bf00;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  text-align: -webkit-center;
  border-radius: 5px;
  .rdrCalendarWrapper {
    box-sizing: border-box;
    background: #ffffff;
    display: inline-flex;
    border: 1px solid #00bf00;
    border-radius: 5px;
    flex-direction: column;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .rdrDateDisplay {
    display: flex;
    justify-content: space-between;
  }

  .rdrDateDisplayItem {
    flex: 1 1;
    width: 0;
    text-align: center;
    color: inherit;
  }

  .rdrDateDisplayItem + .rdrDateDisplayItem {
    margin-left: 0.833em;
  }

  .rdrDateDisplayItem input {
    text-align: inherit;
  }

  .rdrDateDisplayItem input:disabled {
    cursor: default;
  }

  .rdrDateDisplayItemActive {
  }

  .rdrMonthAndYearWrapper {
    box-sizing: inherit;
    display: flex;
    justify-content: space-between;
  }

  .rdrMonthAndYearPickers {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    select {
      font-weight: bold;
      font-size: 16px;
      line-height: 23px;
      color: #000000 !important;
    }
  }

  .rdrMonthPicker {
  }

  .rdrYearPicker {
  }

  .rdrNextPrevButton {
    box-sizing: inherit;
    cursor: pointer;
    outline: none;
    background: unset !important;
    & > i {
      border: solid black;
      border-width: 0 3px 3px 0;
      display: inline-block;
      padding: 4px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
  }

  .rdrPprevButton {
  }

  .rdrNextButton {
  }

  .rdrMonths {
    display: flex;
    border-radius: 14px;
  }

  .rdrMonthsVertical {
    flex-direction: column;
  }

  .rdrMonthsHorizontal > div > div > div {
    display: flex;
    flex-direction: row;
  }

  .rdrMonth {
    width: 25.667em;
  }

  .rdrWeekDays {
    display: flex;
  }

  .rdrWeekDay {
    flex-basis: calc(100% / 7);
    box-sizing: inherit;
    text-align: center;
  }

  .rdrDays {
    display: flex;
    flex-wrap: wrap;
  }

  .rdrDateDisplayWrapper {
  }

  .rdrMonthName {
  }

  .rdrInfiniteMonths {
    overflow: auto;
  }

  .rdrDateRangeWrapper {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .rdrDateInput {
    position: relative;
  }

  .rdrDateInput input {
    outline: none;
  }

  .rdrDateInput .rdrWarning {
    position: absolute;
    font-size: 1.6em;
    line-height: 1.6em;
    top: 0;
    right: 0.25em;
    color: #ff0000;
  }

  .rdrDay {
    box-sizing: inherit;
    width: calc(100% / 7);
    position: relative;
    font: inherit;
    cursor: pointer;
  }

  .rdrDayNumber {
    display: block;
    position: relative;
  }

  .rdrDayNumber span {
    color: #1d2429;
  }

  .rdrDayDisabled {
    cursor: not-allowed;
  }

  @supports (-ms-ime-align: auto) {
    .rdrDay {
      flex-basis: 14.285% !important;
    }
  }

  .rdrSelected,
  .rdrInRange,
  .rdrStartEdge,
  .rdrEndEdge {
    pointer-events: none;
  }

  .rdrInRange {
  }

  .rdrDayStartPreview,
  .rdrDayInPreview,
  .rdrDayEndPreview {
    pointer-events: none;
  }

  .rdrDayHovered {
  }

  .rdrDayActive {
  }

  .rdrDateRangePickerWrapper {
    display: inline-flex;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .rdrDefinedRangesWrapper {
  }

  .rdrStaticRanges {
    display: flex;
    flex-direction: column;
  }

  .rdrStaticRange {
    font-size: inherit;
  }

  .rdrStaticRangeLabel {
  }

  .rdrInputRanges {
  }

  .rdrInputRange {
    display: flex;
  }

  .rdrInputRangeInput {
  }
  .rdrCalendarWrapper {
    color: #000000;
    font-size: 12px;
    border-radius: 5px;
  }

  .rdrDateDisplayWrapper {
    background-color: rgb(239, 242, 247);
  }

  .rdrDateDisplay {
    margin: 0.833em;
  }

  .rdrDateDisplayItem {
    border-radius: 4px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0 1px 2px 0 rgba(35, 57, 66, 0.21);
    border: 1px solid transparent;
  }

  .rdrDateDisplayItem input {
    cursor: pointer;
    height: 2.5em;
    line-height: 2.5em;
    border: 0;
    background: transparent;
    width: 100%;
    color: #849095;
  }

  .rdrDateDisplayItemActive {
    border-color: currentColor;
  }

  .rdrDateDisplayItemActive input {
    color: #7d888d;
  }

  .rdrMonthAndYearWrapper {
    align-items: center;
    height: 60px;
    padding-top: 10px;
  }

  .rdrMonthAndYearPickers {
    font-weight: 600;
  }

  .rdrMonthAndYearPickers select {
    -moz-appearance: none;
    appearance: none;
    -webkit-appearance: none;
    border: 0;
    background: transparent;
    padding: 5px 20px 5px 10px;
    border-radius: 4px;
    outline: 0;
    color: #3e484f;
    background: url("data:image/svg+xml;utf8,<svg width='9px' height='6px' viewBox='0 0 9 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Artboard' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(-636.000000, -171.000000)' fill-opacity='0.368716033'><g id='input' transform='translate(172.000000, 37.000000)' fill='%230E242F' fill-rule='nonzero'><g id='Group-9' transform='translate(323.000000, 127.000000)'><path d='M142.280245,7.23952813 C141.987305,6.92353472 141.512432,6.92361662 141.219585,7.23971106 C140.926739,7.5558055 140.926815,8.06821394 141.219755,8.38420735 L145.498801,13 L149.780245,8.38162071 C150.073185,8.0656273 150.073261,7.55321886 149.780415,7.23712442 C149.487568,6.92102998 149.012695,6.92094808 148.719755,7.23694149 L145.498801,10.7113732 L142.280245,7.23952813 Z' id='arrow'></path></g></g></g></svg>")
      no-repeat;
    background-position: right 8px center;
    cursor: pointer;
    text-align: center;
  }

  .rdrMonthAndYearPickers select:hover {
    background-color: rgba(0, 0, 0, 0.07);
  }

  .rdrMonthPicker,
  .rdrYearPicker {
    margin: 0 5px;
  }

  .rdrNextPrevButton {
    display: block;
    width: 24px;
    height: 24px;
    margin: 0 0.833em;
    padding: 0;
    border: 0;
    border-radius: 5px;
    background: #eff2f7;
  }

  .rdrNextPrevButton:hover {
    background: #e1e7f0;
  }

  .rdrNextPrevButton i {
    border: solid black;
    border-width: 0 2px 2px 0;
    border-radius: 0;
    display: inline-block;
    padding: 3px;
  }

  .rdrPprevButton i {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  .rdrNextButton i {
  }

  .rdrWeekDays {
    padding: 0 0.833em;
  }

  .rdrMonth {
    padding: 0 0.833em 1.666em 0.833em;
  }

  .rdrMonth .rdrWeekDays {
    padding: 0;
  }

  .rdrMonths.rdrMonthsVertical .rdrMonth:first-of-type .rdrMonthName {
    display: none;
  }

  .rdrWeekDay {
    font-weight: 400;
    line-height: 2.667em;
    color: rgb(132, 144, 149);
  }

  .rdrDay {
    background: transparent;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 0;
    padding: 0;
    line-height: 3em;
    height: 3em;
    text-align: center;
    color: #1d2429;
  }

  .rdrDay:focus {
    outline: 0;
  }

  .rdrDayNumber {
    outline: 0;
    font-weight: 300;
    position: absolute;
    left: 0;
    right: 0;
    top: 5px;
    bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rdrDayToday .rdrDayNumber span {
    font-weight: 500;
  }

  .rdrDayToday .rdrDayNumber span::after {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 18px;
    height: 2px;
    border-radius: 4px;
    background: #7fe200;
  }

  .rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span::after,
  .rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span::after,
  .rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span::after,
  .rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span::after {
    background: #fff;
  }

  .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    color: rgba(255, 255, 255, 0.85);
  }

  .rdrSelected,
  .rdrInRange,
  .rdrStartEdge,
  .rdrEndEdge {
    background: currentColor;
    position: absolute;
    top: 5px;
    left: 0;
    right: 0;
    bottom: 5px;
  }

  .rdrSelected {
    left: 2px;
    right: 2px;
  }

  .rdrInRange {
    color: #7fe200 !important;
  }

  .rdrStartEdge {
    background-color: #7fe200;
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    left: 2px;
  }

  .rdrEndEdge {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    right: 2px;
    color: #7fe200 !important;
  }

  .rdrSelected {
    border-radius: 1.042em;
  }

  .rdrDayStartOfMonth .rdrInRange,
  .rdrDayStartOfMonth .rdrEndEdge,
  .rdrDayStartOfWeek .rdrInRange,
  .rdrDayStartOfWeek .rdrEndEdge {
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    left: 2px;
  }

  .rdrDayEndOfMonth .rdrInRange,
  .rdrDayEndOfMonth .rdrStartEdge,
  .rdrDayEndOfWeek .rdrInRange,
  .rdrDayEndOfWeek .rdrStartEdge {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    right: 2px;
  }

  .rdrDayStartOfMonth .rdrDayInPreview,
  .rdrDayStartOfMonth .rdrDayEndPreview,
  .rdrDayStartOfWeek .rdrDayInPreview,
  .rdrDayStartOfWeek .rdrDayEndPreview {
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    border-left-width: 1px;
    left: 0;
  }

  .rdrDayEndOfMonth .rdrDayInPreview,
  .rdrDayEndOfMonth .rdrDayStartPreview,
  .rdrDayEndOfWeek .rdrDayInPreview,
  .rdrDayEndOfWeek .rdrDayStartPreview {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    border-right-width: 1px;
    right: 0;
  }

  .rdrDayStartPreview,
  .rdrDayInPreview,
  .rdrDayEndPreview {
    position: absolute;
    top: 3px;
    left: 0;
    right: 0;
    bottom: 3px;
    width: 30px !important;
    height: 30px !important;
    pointer-events: none;
    border: 0 solid #7fe200;
    z-index: 1;
  }

  .rdrDayStartPreview {
    border-top-width: 1px;
    border-left-width: 1px;
    border-bottom-width: 1px;
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    left: 0;
  }

  .rdrDayInPreview {
    border-top-width: 1px;
    border-bottom-width: 1px;
  }

  .rdrDayEndPreview {
    border-top-width: 1px;
    border-right-width: 1px;
    border-bottom-width: 1px;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    right: 0;
  }

  .rdrDefinedRangesWrapper {
    font-size: 12px;
    width: 226px;
    border-right: solid 1px #eff2f7;
    background: #fff;
  }

  .rdrDefinedRangesWrapper .rdrStaticRangeSelected {
    color: currentColor;
    font-weight: 600;
  }

  .rdrStaticRange {
    border: 0;
    cursor: pointer;
    display: block;
    outline: 0;
    border-bottom: 1px solid #eff2f7;
    padding: 0;
    background: #fff;
  }

  .rdrStaticRange:hover .rdrStaticRangeLabel,
  .rdrStaticRange:focus .rdrStaticRangeLabel {
    background: #eff2f7;
  }

  .rdrStaticRangeLabel {
    display: block;
    outline: 0;
    line-height: 18px;
    padding: 10px 20px;
    text-align: left;
  }

  .rdrInputRanges {
    padding: 10px 0;
  }

  .rdrInputRange {
    align-items: center;
    padding: 5px 20px;
  }

  .rdrInputRangeInput {
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    text-align: center;
    border: solid 1px rgb(222, 231, 235);
    margin-right: 10px;
    color: rgb(108, 118, 122);
  }

  .rdrInputRangeInput:focus,
  .rdrInputRangeInput:hover {
    border-color: rgb(180, 191, 196);
    outline: 0;
    color: #333;
  }

  .rdrCalendarWrapper:not(.rdrDateRangeWrapper) {
    .rdrDayHovered {
      .rdrDayNumber::after {
        content: '';
        border: 1px solid currentColor;
        border-radius: 1.333em;
        position: absolute;
        top: -2px;
        bottom: -2px;
        left: 0;
        right: 0;
        background: transparent;
      }
    }
  }

  .rdrDayPassive {
    pointer-events: none;
  }
  .rdrDayPassive span {
    color: #fff !important;
  }

  .rdrDayPassive .rdrDayNumber span {
    color: #d5dce0;
  }

  .rdrDayPassive .rdrInRange,
  .rdrDayPassive .rdrStartEdge,
  .rdrDayPassive .rdrEndEdge,
  .rdrDayPassive .rdrSelected,
  .rdrDayPassive .rdrDayStartPreview,
  .rdrDayPassive .rdrDayInPreview,
  .rdrDayPassive .rdrDayEndPreview {
    display: none;
  }

  .rdrDayDisabled {
    background-color: #fff;
  }

  .rdrDayDisabled .rdrDayNumber span {
    color: #e6e6e6;
  }

  .rdrDayDisabled .rdrInRange,
  .rdrDayDisabled .rdrStartEdge,
  .rdrDayDisabled .rdrEndEdge,
  .rdrDayDisabled .rdrSelected,
  .rdrDayDisabled .rdrDayStartPreview,
  .rdrDayDisabled .rdrDayInPreview,
  .rdrDayDisabled .rdrDayEndPreview {
    background-color: #ddd;
  }

  .rdrMonthName {
    text-align: left;
    font-weight: 600;
    color: #849095;
    padding: 0.833em;
  }

  .rdrDayPassive .rdrDayNumber span::after {
    content: none;
  }

  .rdrDay span {
    top: -1px;
    width: 32px;
    height: 32px;
    margin: 0 auto;
  }
  .rdrDay .rdrDayNumber {
    margin-top: -3px;
  }

  .rdrStartEdge.rdrEndEdge {
    border-radius: 50%;
  }

  .rdrStartEdge::after {
    content: '';
    display: block;
    width: 15px;
    height: 32px;
    margin-left: 24px;
    background-color: #7fe200;
  }

  .rdrEndEdge::before {
    content: '';
    position: absolute;
    top: 0;
    left: -7px;
    width: 15px;
    height: 32px;
    background-color: #7fe200;
  }

  .rdrInRange::before {
    content: '';
    position: absolute;
    top: 0;
    left: -7px;
    width: 15px;
    height: 32px;
    background-color: #7fe200;
  }

  .rdrInRange::after {
    content: '';
    position: absolute;
    top: 0;
    right: -11px;
    width: 15px;
    height: 32px;
    background-color: #7fe200;
  }

  .rdrDayDisabled {
    background-color: transparent;
  }

  .rdrDayDisabled .rdrInRange::before,
  .rdrDayDisabled .rdrInRange::after {
    background-color: #ddd;
  }

  .rdrDayStartPreview::after {
    content: '';
    display: inline-block;
    width: 15px;
    height: 30px;
    margin-top: -1px;
    margin-left: 24px;
    border: 0 solid #7fe200;
    border-top-width: 1px;
    border-bottom-width: 1px;
  }

  .rdrDayInPreview::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -6px;
    width: 15px;
    height: 30px;
    border: 0 solid #7fe200;
    border-top-width: 1px;
    border-bottom-width: 1px;
  }

  .rdrDayInPreview::after {
    content: '';
    position: absolute;
    top: -1px;
    right: -10px;
    width: 15px;
    height: 30px;
    border: 0 solid #7fe200;
    border-top-width: 1px;
    border-bottom-width: 1px;
  }

  .rdrDayEndPreview::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -6px;
    width: 15px;
    height: 30px;
    border: 0 solid #7fe200;
    border-top-width: 1px;
    border-bottom-width: 1px;
  }

  .rdrDayEndOfWeek .rdrDayInPreview::before {
    content: '';
    position: absolute;
    top: -1px;
    right: -10px;
    width: 15px;
    height: 30px;
    border: 0 solid #7fe200;
    border-top-width: 1px;
    border-bottom-width: 1px;
  }

  .rdrStartEdge.rdrEndEdge::before,
  .rdrStartEdge.rdrEndEdge::after,
  .rdrDayStartPreview.rdrDayEndPreview::before,
  .rdrDayStartPreview.rdrDayEndPreview::after,
  .rdrDayStartOfMonth .rdrInRange::before,
  .rdrDayStartOfMonth .rdrEndEdge::before,
  .rdrDayStartOfMonth .rdrDayEndPreview::before,
  .rdrDayEndOfMonth .rdrInRange::after,
  .rdrDayEndOfMonth .rdrDayInPreview::after,
  .rdrDayStartOfWeek .rdrInRange::before,
  .rdrDayStartOfWeek .rdrEndEdge::before,
  .rdrDayStartOfWeek .rdrDayInPreview::before,
  .rdrDayStartOfWeek .rdrDayEndPreview::before,
  .rdrDayEndOfWeek .rdrStartEdge::before,
  .rdrDayEndOfWeek .rdrStartEdge::after,
  .rdrDayEndOfWeek .rdrInRange::after,
  .rdrDayEndOfWeek .rdrDayStartPreview::before,
  .rdrDayEndOfWeek .rdrDayStartPreview::after,
  .rdrDayEndOfWeek .rdrDayInPreview::after {
    content: none;
  }
`;

export const DateRangeStatic = styled.div`
  display: flex;
  box-sizing: border-box;
  margin: 5px 0 20px;

  & > button[data-value=${(props: any) => props['data-selected']}] {
    background-color: #00bf00;
    color: #ffffff;
  }

  &.logdaterange {
    margin: unset;
    & > button {
      width: 45px;
      font-weight: 400;
      font-size: 12px;

      &.customrange {
        position: relative;
        width: 164px;
      }

      & input {
        font-weight: 400;
        font-size: 12px;
      }
    }
    & > button[data-value=${(props: any) => props['data-selected']}] {
      background-color: #00bf00;
      color: #ffffff;
      font-weight: 700;

      font-size: 12px;
    }
    & > button[data-value=${(props: any) => props['data-selected']}] input {
      background-color: #00bf00;
      color: #ffffff;
      font-weight: 700;
      font-size: 12px;
    }
  }
`;

export const DateRangeButton = styled.button`
  z-index: 1;
  display: flex;
  flex: 1;
  min-width: 64px;
  height: 31px;
  margin: 0 -1px;
  align-items: center;
  place-content: center;
  font-weight: bold;
  cursor: pointer;
  background-color: #ffffff;
  border: 1px solid #00bf00;
  color: #999999;
  &:nth-of-type(1) {
    border-radius: 30px 0 0 30px;
    padding: 0 24px;
  }
  &:nth-last-of-type(1) {
    border-radius: 0 30px 30px 0;
    padding: 0 24px;
  }
  &.selected {
    background-color: #454d53;
    color: #7fe200;
  }

  &.left {
    border-radius: 30px 0 0 30px;
  }

  &.right {
    border-radius: 0 30px 30px 0;
  }

  &:hover {
    background-color: #effdda;
  }

  &:active {
    background-color: #7fe200;
    color: white;
  }
`;

export const CustomDateRangeButton = styled.button`
  z-index: 1;
  display: flex;
  /* flex: 1; */
  height: 31px;
  margin: 0 -1px;
  align-items: center;
  place-content: center;
  font-weight: 400;
  cursor: pointer;
  background-color: #ffffff;
  border: 1px solid #00bf00;
  color: #777;
  &:nth-of-type(1) {
    border-radius: 30px 0 0 30px;
  }
  &:nth-last-of-type(1) {
    border-radius: 0 30px 30px 0;
    /* padding: 0 24px; */
  }
  &.selected {
    background-color: #454d53;
    color: #7fe200;
  }

  &.left {
    border-radius: 30px 0 0 30px;
  }

  &.right {
    border-radius: 0 30px 30px 0;
  }

  &:hover {
    background-color: #effdda;
  }

  &:active {
    background-color: #7fe200;
    color: white;
  }

  &.customrange {
    position: relative;

    width: 164px;

    & > section {
      width: 164px;
      height: 100%;
      right: 27px;

      & > div {
        top: 39px;
        left: -21px;

        padding: unset;
        border: unset;
        width: 320px;
      }

      & > input {
        outline: none;
        border: none !important;
        border-radius: 0 30px 30px 0 !important;

        width: 164px;
        height: 100%;

        position: absolute;
        left: 0;

        color: #777;

        &::placeholder {
          position: relative;
          left: 6px;
          color: #777;
          font-size: 12px;
        }

        &:hover {
          border: none !important;
        }

        &:active {
          background-color: #7fe200;
          color: white;
        }

        input:focus {
          border: none;
          outline: none;
          box-shadow: none;
        }
      }

      & > span {
        display: none;
      }
    }
  }
`;
